module.exports = __webpack_public_path__ + "static/media/Crown_Agents_logo.dbb95afa.jpg";